// Mapping: <GET param>: <Affiliates API parameter>
const affAttributes = {
  aff_id: 'webmaster',
  aff_pg: 'program',
  aff_cp: 'campaign',
  aff_adg: 'adgroup',
  aff_kw: 'keywords',
  aff_src: 'source',
  track_id: 'track_id',
  track_id2: 'track_id2',
  aff_plmt: 'placement',
  banner: 'banner',
  target: 'target',
  webmaster: 'webmaster',
  program: 'program',
  campaign: 'campaign',
  adgroup: 'adgroup',
  keywords: 'keywords',
  source: 'source',
  placement: 'placement',
};

// http://dev.hippie.dating/signup?aff_pg=PPU&aff_src=www.meetlocalbikers.com&aff_id=dvipcoreg
// https://www.hippie.dating/signup?aff_pg=PPU&aff_src=www.meetlocalbikers.com&aff_id=dvipcoreg
// http://localhost:3000/signup?aff_pg=PPU&aff_src=www.meetlocalbikers.com&aff_id=dvipcoreg
export function extractAffiliateParamsFromUrl(urlParams, referrer = '') {
  const affParams = {};

  if (urlParams && urlParams.entries) {
    for (let pair of urlParams.entries()) {
      if (typeof affAttributes[pair[0]] !== 'undefined' && pair[1] !== '') {
        const affApiParam = affAttributes[pair[0]];
        if (
          Object.prototype.hasOwnProperty.call(affParams, affApiParam) &&
          affParams[affApiParam] !== pair[1]
        ) {
          affParams[affApiParam] = affParams[affApiParam] + ',' + pair[1];
        } else {
          affParams[affApiParam] = pair[1];
        }
      }
    }
  }

  // for (let key in urlParams) {
  //   if (key.indexOf('aff_') === 0) {
  //     if (typeof affAttributes[key] !== undefined) {
  //       const affApiParam = affAttributes[key];
  //       affParams[affApiParam] = urlParams[key];
  //     }
  //   }
  // }

  if (affParams.source === undefined && referrer !== '') {
    affParams.source = referrer;
  }

  for (let key in affParams) {
    if (key === undefined || key === 'undefined') {
      delete affParams[key];
    }
  }

  setAffiliateParams(affParams);
  return affParams;
}

export function setAffiliateParams(params) {
  localStorage.setItem('__AFFILIATE_PARAMS__', JSON.stringify(params));
}

export function getAffiliateParams() {
  const currentAffParams = localStorage.getItem('__AFFILIATE_PARAMS__');
  if (currentAffParams === null) {
    return {};
  } else {
    return JSON.parse(currentAffParams);
  }
}

export function getLandingId() {
  const landingId = localStorage.getItem('__LANDING_ID__');
  if (landingId === null) {
    return '';
  } else {
    return JSON.parse(landingId).landingId;
  }
}

export function setLandingId(landingId) {
  localStorage.setItem('__LANDING_ID__', JSON.stringify({ landingId }));
}

export function prepareAffiliateParams(params = {}, forSignup = false) {
  const affParams = getAffiliateParams();
  const landingId = getLandingId();
  const obj = {};
  const prefix = forSignup ? 'affiliate_data' : 'data';

  if (!forSignup) {
    obj.landing_id = landingId;
  }

  for (let key in affParams) {
    obj[`${prefix}[${key}]`] = affParams[key];
  }

  if (Object.keys(params).length > 0) {
    for (let key in params) {
      obj[`${prefix}[${key}]`] = params[key];
    }
  }

  return obj;
}

export function deleteAllAffiliateParams() {
  localStorage.removeItem('__LANDING_ID__');
  localStorage.removeItem('__AFFILIATE_PARAMS__');
}
